
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/shaker",
      function () {
        return require("private-next-pages/features/shaker.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/shaker"])
      });
    }
  